import React from 'react';
import { Box, styled } from '@mui/material';

export const VBox = styled(
  Box,
  {
    name: 'VBox',
    slot: 'root'
  }
)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '10pt'
}))
